export default "__VITE_ASSET__DXesUx1W__"